import { render, staticRenderFns } from "./TraineeSettings.vue?vue&type=template&id=68801b4e&"
import script from "./TraineeSettings.vue?vue&type=script&lang=js&"
export * from "./TraineeSettings.vue?vue&type=script&lang=js&"
import style0 from "./TraineeSettings.vue?vue&type=style&index=0&id=68801b4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports